import { Skeleton, Stack } from "@mui/material";

export function HelpCenterLoadingState() {
  return (
    <Stack spacing={3}>
      {["card-1", "card-2", "card-3", "card-4"].map((id) => (
        <Skeleton
          key={id}
          variant="rounded"
          height={72}
          sx={(theme) => ({ borderRadius: theme.borderRadius?.xLarge })}
        />
      ))}
    </Stack>
  );
}
